export default __webpack_public_path__ + "d8be12b05372a5f23ffbef0f8ea11bfb.svg";